import React from "react";

import {getUser} from "../../util/common/Common";
import {CardComplete, CustomInput, GridItem} from "../../components";
import ThemeToggleButton from "components/Button/ThemeToggleButton";


export default function UserProfile() {

    const [user] = React.useState(getUser());

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "40px",
            }}
        >
            <div style={{width: "50%", minWidth: 300}}>
                <CardComplete titulo={'Perfil de Usuario'}>
                    <GridItem>
                        <CustomInput
                            labelText="Nombre"
                            value={user.name}
                            disabled={true}
                        />
                        <CustomInput
                            labelText="Usuario"
                            value={user.username}
                            disabled={true}
                        />
                        <CustomInput
                            labelText="Correo electrónico"
                            value={user.email}
                            disabled={true}
                        />
                        <CustomInput
                            labelText="Rol"
                            value={user.roles[0].name || ""}
                            disabled={true}
                        >
                        </CustomInput>
                    </GridItem>

                </CardComplete>
            </div>
        </div>
    );
}
